// 旅行業登録者定義照会・更新画面の一覧表のラベル
export const LABELS = {
  TITLE: "旅行業登録者定義",

  TOURIST_INDUSTRIES_NO: "旅行業者登録番号",
  CORPORATE_NUMBER: "法人番号",
  COMPANY_NAME: "事業者名称",
  UPLOAD_CONFIRM:
    "アップロード前件数：{0}件\r\nアップロード後件数：{1}件\r\n新規：{2}件\n/\n更新：{3}件\n/\n削除：{4}件",
  LAST_UPDATER: "最終更新者:",
  LAST_UPDATING_TIME: "最終更新日時:",
} as const;

export const CONFIGS = {
  FILE: "file",
  FILE_EXTENSION: ".csv",
  SUCCESS: "success",
} as const;
